// extracted by mini-css-extract-plugin
export default {"infoButton":"GroupTalkTextListInfo_infoButton__ZaxEv"};